// extracted by mini-css-extract-plugin
export default {"actions":"TagListPage_actions__-IyUX","labelExportButton":"TagListPage_labelExportButton__egk9O","search":"TagListPage_search__dAj8+"};